import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UzurvDirectivesModule } from '@uzurv/core';
import { MaterialModule } from '../../../app/material.module';
import { AlertDialogModule } from '../alert-dialog/alert-dialog.module';
import { RejectChangeRequestDialogComponent } from './reject-change-request-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [RejectChangeRequestDialogComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, UzurvDirectivesModule, MaterialModule, AlertDialogModule, MatFormFieldModule],
  exports: [RejectChangeRequestDialogComponent]
})
export class RejectChangeRequestDialogModule {}
